
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCameraTop as ObiCameraTopElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-camera-top.js';
 
 
 

 
 export const ObiCameraTop = createComponent({
   react: React,
   tagName: 'obi-camera-top',
   elementClass: ObiCameraTopElement,
   events: {
     
   }
  });
 
 